import React from 'react';
import classnames from 'classnames';
import './icons.scss';

import CollapseSVG from '../../../images/svg/collapse';
import ExpandSVG from '../../../images/svg/expand';
import MinimizeSVG from '../../../images/svg/minimize';
import MaximizeSVG from '../../../images/svg/maximize';
import EditSVG from '../../../images/svg/icons8-edit';
import CloseXSVG from '../../../images/svg/closeX';
import ExpandArrowSVG from '../../../images/svg/icons8-expand-arrow';
import DoubleUpSVG from '../../../images/svg/icons8-double-up';
import CircledWSVG from '../../../images/svg/icons8-circled-w';
import LockSVG from '../../../images/svg/icons8-lock';
import OpenMessageSVG from '../../../images/svg/icons8-open-message';
import SelectLeftColumnSVG from '../../../images/svg/icons8-select-left-column';
import PresenterPortalAccessSVG from '../../../images/svg/lecturer';
import InfoSVG from '../../../images/svg/info';
import EyeSVG from '../../../images/svg/eye';
import PhoneSVG from '../../../images/svg/phone';
import ArrowSVG from '../../../images/svg/arrow';
import GenerateWithAISVG from '../../../images/svg/generate-with-ai';
import WarningSVG from '../../../images/svg/warning';

const createMaterialIcon = (iconTextCode: string, customClass?: string) => {
    return (props: React.HTMLAttributes<HTMLSpanElement>) => {
        const finalProps = {
            ...props,
            className: 'oe-icon material-icons'
                + (customClass ? ' ' + customClass : '' )
                + (props.className ? ' ' + props.className : ''),
        };
        return <i {...finalProps}>{iconTextCode}</i>;
    };
};

const createSvgIcon = (SvgIcon: React.FunctionComponent, customClass?: string) => {
    return (props: React.HTMLAttributes<HTMLSpanElement>) => (
        <div className={classnames('oe-icon oe-icon__svg', customClass)} {...props}>
            <SvgIcon />
        </div>
    );
};

export const OpenIcon = createMaterialIcon('launch');
export const CopyIcon = createMaterialIcon('file_copy');
export const CloseIcon = createMaterialIcon('close');
export const SyncIcon = createMaterialIcon('sync');
export const ChevronDownIcon = createMaterialIcon('keyboard_arrow_down');
export const ChevronUpIcon = createMaterialIcon('keyboard_arrow_up');
export const SuccessIcon = createMaterialIcon('check_circle_outline');
export const ErrorIcon = createMaterialIcon('error_outline');
export const WarningIcon = createMaterialIcon('warning');
export const NotificationIcon = createMaterialIcon('comment_outline');
export const PlayIcon = createMaterialIcon('play_arrow');
export const MenuIcon = createMaterialIcon('menu');
export const ExpandIcon = createSvgIcon(ExpandSVG);
export const CollapseIcon = createSvgIcon(CollapseSVG);
export const MinimizeIcon = createSvgIcon(MinimizeSVG);
export const MaximizeIcon = createSvgIcon(MaximizeSVG);
export const EditIcon = createSvgIcon(EditSVG);
export const CloseXIcon = createSvgIcon(CloseXSVG);
export const ExpandArrowDownIcon = createSvgIcon(ExpandArrowSVG, 'expand-arrow');
export const ExpandArrowUpIcon = createSvgIcon(ExpandArrowSVG, 'expand-arrow expand-arrow__up');
export const DoubleUpIcon = createSvgIcon(DoubleUpSVG, 'expand-arrow');
export const CircledWIcon = createSvgIcon(CircledWSVG);
export const LockIcon = createSvgIcon(LockSVG);
export const OpenMessageIcon = createSvgIcon(OpenMessageSVG);
export const SelectLeftColumnIcon = createSvgIcon(SelectLeftColumnSVG);
export const PresenterPortalAccessIconDisabled = createSvgIcon(PresenterPortalAccessSVG, 'presenter-portal-access-disabled');
export const PresenterPortalAccessIcon = createSvgIcon(PresenterPortalAccessSVG);
export const InfoIcon = createSvgIcon(InfoSVG);
export const EyeIcon = createSvgIcon(EyeSVG);
export const PhoneIcon = createSvgIcon(PhoneSVG);
export const ArrowIcon = createSvgIcon(ArrowSVG);
export const GenerateWithAIIcon = createSvgIcon(GenerateWithAISVG);
export const WarningErrorIcon = createSvgIcon(WarningSVG);
